import {DESK_COMPANY, DESK_CONTACTS, DESK_DESK} from './endpoint'
import {apiAction} from './api'
import {
  ADD_SEGMENT,
  UPDATE_SEGMENT,
  DELETE_SEGMENT,
  GET_SEGMENT,
  GET_ALL_SEGMENT,
  GET_STATIC_CONTACT,
  GET_ALL_COMPANY_SEGMENT,
  GET_STATIC_COMPANY,
  GET_COMPANY_SEGMENT,
  DELETE_COMPANY_SEGMENT,
  UPDATE_COMPANY_SEGMENT,
  ADD_COMPANY_SEGMENT,
} from './types'

const handleSection = type => {
  if (type === 'customers') {
    return DESK_CONTACTS
  }
  if (type === 'company') {
    return DESK_COMPANY
  }
}

export function addSegment({type, data}) {
  return apiAction({
    url: `${handleSection(type)}/segment`,
    method: 'POST',
    label: ADD_SEGMENT,
    data,
    showToast: true,
    successMessage: 'Segment Created ',
  })
}
export function addCompanySegment(type, data) {
  return apiAction({
    url: `${handleSection(type)}/segment`,
    method: 'POST',
    label: ADD_COMPANY_SEGMENT,
    data,
    showToast: true,
    successMessage: 'Segment Created ',
  })
}

export function updateSegment({type, data, id}) {
  return apiAction({
    url: `${handleSection(type)}/segment/${id}`,
    method: 'PUT',
    label: UPDATE_SEGMENT,
    data,
    showToast: true,
    successMessage: 'Segment Updated ',
  })
}
export function updateCompanySegment(type, data, id) {
  return apiAction({
    url: `${handleSection(type)}/segment/${id}`,
    method: 'PUT',
    label: UPDATE_COMPANY_SEGMENT,
    data,
    showToast: true,
    successMessage: 'Segment Updated ',
  })
}

export function deleteSegment({type, id}) {
  return apiAction({
    url: `${handleSection(type)}/segment/${id}`,
    method: 'DELETE',
    label: DELETE_SEGMENT,
    showToast: true,
    successMessage: 'Segment Deleted ',
  })
}
export function deleteCompanySegment(type, id) {
  return apiAction({
    url: `${handleSection(type)}/segment/${id}`,
    method: 'DELETE',
    label: DELETE_COMPANY_SEGMENT,
    showToast: true,
    successMessage: 'Segment Deleted ',
  })
}

export function getSegment({type, id}) {
  return apiAction({
    url: `${handleSection(type)}/segment/${id}`,
    method: 'GET',
    label: GET_SEGMENT,
  })
}
export function getCompanySegment(type, id) {
  return apiAction({
    url: `${handleSection(type)}/segment/${id}`,
    method: 'GET',
    label: GET_COMPANY_SEGMENT,
  })
}

export function getAllSegment() {
  return apiAction({
    url: `${DESK_CONTACTS}/segments`,
    method: 'GET',
    label: GET_ALL_SEGMENT,
  })
}

export function getAllCompanySegment() {
  return apiAction({
    url: `${DESK_DESK}/companies/segments`,
    method: 'GET',
    label: GET_ALL_COMPANY_SEGMENT,
  })
}

export function getStaticSegmentContactList(type, params = {}) {
  return apiAction({
    url: handleSection(type),
    method: 'GET',
    label: GET_STATIC_CONTACT,
    params,
  })
}

export function getStaticSegmentCompanyList(type, params = {}) {
  return apiAction({
    url: handleSection(type),
    method: 'GET',
    label: GET_STATIC_COMPANY,
    params,
  })
}
